import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJsdelivrComponent } from './simple-icons-jsdelivr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJsdelivrComponent ],
    exports:      [ SimpleIconsJsdelivrComponent ],
    bootstrap:    []
})
export class SimpleIconsJsdelivrModule {}
